const id = store => {
  store.on("@init", () => ({ id: null, cartId: null, orderId: null }));
  store.on("id/set", (_, id) => {
    return { id };
  });
  store.on("cartId/set", (_, cartId) => {
    return { cartId };
  });
  store.on("orderId/set", (_, orderId) => {
    return { orderId };
  });
};

export default id;
